export default "# Hello\r\n> created: 2021.07.06\r\n---\r\n## hello everyone\r\nThis is from Honminden!";